export default {
  buttons: {
    prev: "上一步",
    next: "下一步",
    finish: "完成",
    close: "✕",
  },
};

